export default {
    infoNoData: 'common.MESSAGE.NO_DATA',
    errorExclamation: 'common.oh_no',
    errorCommon: 'errors.common_error',
    updateAvailable: 'common.update_app.available',
    updateInstall: 'common.update_app.install',
    updateCancel: 'common.update_app.cancel'
}